import {Provider} from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import store from './redux-store';
import App from './components/App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <div style={{height:'100%'}}>
        <div id="myConfirmationContainer"></div>
        <App />
      </div>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
